// extracted by mini-css-extract-plugin
export default {"container":"kca-z","list":"lca-z"};